import { getAuthToken } from "../constants/config/authentication";

/**
 * Remove the existing userInfo object before proceeding
 */
const removeExistingInfoObject = () => {
  if ( window.adobeDataLayer ) {
    const existingInfoIndex = window.adobeDataLayer.findIndex( obj => !!obj.userInfo );
    if ( existingInfoIndex > -1 ) {
      window.adobeDataLayer.splice( existingInfoIndex, 1 ); 
    }
  }
};

/**
 *  This function handles the creation and pushing of page view data to Adobe Data Layer
 *  based on the local analytics object and DOM elements on the page.
 */
export function updateAdobeDataLayer(analyticsObj) {
  removeExistingInfoObject();
  const pageViewObject = {
    event: "pageview"
  };
  if (analyticsObj) {
    const pageURL = window.location.href;
    const { 
      title: pageName,
      id: sitecoreItemID, 
      breadCrumbUrl 
    } = analyticsObj;

    let previousPageName = "";
    let previousPageUrl = "";
    let commonBreadCrumb = "";

    breadCrumbUrl.forEach((breadcrumbObject, index) => {
      commonBreadCrumb =
        index === breadCrumbUrl.length - 1
          ? commonBreadCrumb + breadcrumbObject["name"]
          : commonBreadCrumb + breadcrumbObject["name"] + "/";
    });
    if (window.analyticsObject) {
      previousPageUrl = window.analyticsObject.pageInformation.previousPageUrl;
      previousPageName = previousPageUrl;
      if (previousPageName) {
        previousPageName = previousPageName.split(".html")[0];
        previousPageName = previousPageName.split("/").reverse()[0];
      }
    }
    const categories = pageURL.split("/");
    categories.shift();
    categories.splice(0, 2);

    const [ 
      siteLanguage,
      siteSection1,
      siteSection2,
      siteSection3,
      siteSection4,
      siteSection5
    ] = categories; 

    pageViewObject.pageInfo = {
      pageName,
      pageCategory: "parametric search",
      pageURL,
      pageBreadCrumb: commonBreadCrumb,
      pstID: siteSection2?.replace("#", "") ?? '',
      previousPageName,
      previousPageUrl,
      pageEvents: "",
      siteSection1,
      siteSection2,
      siteSection3,
      siteSection4,
      siteSection5,
      sitecoreItemID,
    };
    pageViewObject.siteInfo = {
      siteLanguage,
    };
  }
  pageViewObject.userInfo = {
    userType: "",
    isLoggedIn: Boolean( getAuthToken() ),
  };
  window.adobeDataLayer = window.adobeDataLayer || [];
  window.adobeDataLayer.push(pageViewObject);
  window.adobeDataLayer.reverse();
  console.log(window.adobeDataLayer);
}